


import React, { useState, useEffect } from 'react';
import {
    Box,
    Typography,
    Grid,
    Paper,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Button,
    FormControlLabel,
    Checkbox,
    IconButton,
    Collapse,
      Dialog,
      DialogTitle,
      DialogContent,
      DialogActions,
      
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';

const Hyperacusis = () => {
    // State for search and patient data
    const [opNumber, setOpNumber] = useState('');
    const [patientData, setPatientData] = useState(null);
    const [hearingLossEar, setHearingLossEar] = useState('');
        const [loading, setLoading] = useState(false);
        const [saveStatus, setSaveStatus] = useState({ message: '', severity: '' });
        const [openPasswordModal, setOpenPasswordModal] = useState(false);
        const [password, setPassword] = useState('');
        const [downloadFormat, setDownloadFormat] = useState('excel');
    const [date, setDate] = useState(''); // Get today's date in YYYY-MM-DD format  
    // State for cause of hyperacusis
    const [otologicalCause, setOtologicalCause] = useState('');
    const [otologicalOther, setOtologicalOther] = useState('');
    const [neurologicalCause, setNeurologicalCause] = useState('');
    const [neurologicalOther, setNeurologicalOther] = useState('');
    const [psychologicalCause, setPsychologicalCause] = useState('');
    const [psychologicalOther, setPsychologicalOther] = useState('');
    const [demographyData, setDemographyData] = useState(null);

    // State for hearing loss
    const [hearingLossPresent, setHearingLossPresent] = useState(false);
    
    // State for right ear
    const [hearingLossTypeRight, setHearingLossTypeRight] = useState('');
    const [hearingLossDegreeRight, setHearingLossDegreeRight] = useState('');
    const [hearingLossConfigRight, setHearingLossConfigRight] = useState('');
    const [hearingLossDurationRight, setHearingLossDurationRight] = useState('');
    
    // State for left ear
    const [hearingLossTypeLeft, setHearingLossTypeLeft] = useState('');
    const [hearingLossDegreeLeft, setHearingLossDegreeLeft] = useState('');
    const [hearingLossConfigLeft, setHearingLossConfigLeft] = useState('');
    const [hearingLossDurationLeft, setHearingLossDurationLeft] = useState('');
    
    const [jhqSeverity, setJhqSeverity] = useState('');

    // State for JHQ and HQ
    const [jhqValue, setJhqValue] = useState('');
    const [hqValue, setHqValue] = useState('');
    const [hqStatus, setHqStatus] = useState('');
    
    // State for recommendations
    const [recommendations, setRecommendations] = useState({
        ent: false,
        soundTherapy: false,
        psychology: false,
        neurology: false,
        psychiatric: false,
        yoga: false
    });

    // State for expanded sections
    const [expanded, setExpanded] = useState({
        cause: true,
        hearingLoss: true,
        jhq: true,
        hq: true,
        recommendations: true
    });


    useEffect(() => {
        const data = localStorage.getItem("demography");
        if (data) {
            try {
                const parsedData = JSON.parse(data);
                setDemographyData(parsedData);
            } catch (error) {
                console.error("Error parsing demography data:", error);
            }
        }
    }, []);

        const handleSearch = async () => {
        try {
            // Search for patient in the database
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/hyperacusis/search/${opNumber}`);
            
            if (!response.ok) {
                throw new Error("Failed to search for patient");
            }
            
            const patient = await response.json();
            setPatientData(patient);
            
            // Store in localStorage for future use
            localStorage.setItem("demography", JSON.stringify(patient));
        } catch (error) {
            console.error("Error:", error);
            setPatientData(null);
            alert("❌ Patient not found. Please try another IP/OP number.");
        }
    };
    const handleRecommendationChange = (name) => (event) => {
        setRecommendations({ ...recommendations, [name]: event.target.checked });
    };

    const toggleSection = (section) => {
        setExpanded({ ...expanded, [section]: !expanded[section] });
    };


 const handleDownloadClick = () => {
    setOpenPasswordModal(true);
  };

const handleDownloadConfirm = async () => {
  const correctKey = "Varun@6361";

  // Validate key entered in modal
  if (password !== correctKey) {
    alert("Incorrect key! Download canceled.");
    setPassword('');
    setOpenPasswordModal(false);
    return;
  }

  setOpenPasswordModal(false);
  setLoading(true);
  setSaveStatus({
    message: `Requesting Hyperacusis Data ${downloadFormat}...`,
    severity: "info",
  });

  try {
    const resp = await fetch(
      `${process.env.REACT_APP_API_URL}/api/reports/download-form`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          table: "hyperacusis_data",
          formName: "Hyperacusis_Data",
          format: downloadFormat,
          key: password   // 🔥 send KEY instead of password
        }),
      }
    );

    if (!resp.ok) {
      const body = await resp.json().catch(() => ({}));
      setSaveStatus({
        message: `Failed: ${body.message || resp.statusText}`,
        severity: "error",
      });
      return;
    }

    const blob = await resp.blob();
    const disposition = resp.headers.get("content-disposition") || "";

    let filename = `Hyperacusis_Data_${Date.now()}.${
      downloadFormat === "excel" ? "xlsx" : "pdf"
    }`;

    const match = /filename="?([^"]+)"?/.exec(disposition);
    if (match && match[1]) filename = match[1];

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);

    setSaveStatus({
      message: `Download started: ${filename}`,
      severity: "success",
    });

  } catch (err) {
    console.error("Download error:", err);
    setSaveStatus({
      message: `Error downloading file: ${err.message}`,
      severity: "error",
    });
  } finally {
    setLoading(false);
    setPassword('');
  }
};


  const handlePasswordModalClose = () => {
    setOpenPasswordModal(false);
    setPassword('');
  };



   const handleSubmit = async () => {
        try {
            // Make sure patientData exists and has an id
            if (!patientData || !patientData.id) {
                throw new Error("Patient information is missing. Please register the patient first.");
            }

            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/hyperacusis`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    patientId: patientData.id,
                    date: date,
                    // Demographic data
                    patientName: patientData.name || '',
                    patientPhone: patientData.phone || '',
                    patientIpNumber: patientData.ip_number || '',
                    patientOpNumber: patientData.op_number || '',
                    patientAddress: patientData.address || '',
                    // Hyperacusis data
                    otologicalCause,
                    otologicalOther,
                    neurologicalCause,
                    neurologicalOther,
                    psychologicalCause,
                    psychologicalOther,
                    hearingLossPresent,
                    hearingLossEar,
                    // Right ear data
                    hearingLossTypeRight,
                    hearingLossDegreeRight,
                    hearingLossConfigRight,
                    hearingLossDurationRight,
                    // Left ear data
                    hearingLossTypeLeft,
                    hearingLossDegreeLeft,
                    hearingLossConfigLeft,
                    hearingLossDurationLeft,
                    jhqSeverity,
                    jhqValue,
                    hqStatus,
                    hqValue,
                    recommendations
                }),
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || "Failed to save hyperacusis data");
            }

            const data = await response.json();
            alert("✅ Hyperacusis data saved successfully!");
            console.log("Saved:", data);
            
            // Reset form
            setPatientData(null);
            setOpNumber('');
            setOtologicalCause('');
            setOtologicalOther('');
            setNeurologicalCause('');
            setNeurologicalOther('');
            setPsychologicalCause('');
            setPsychologicalOther('');
            setHearingLossPresent(false);
            setHearingLossEar('');
            // Reset right ear
            setHearingLossTypeRight('');
            setHearingLossDegreeRight('');
            setHearingLossConfigRight('');
            setHearingLossDurationRight('');
            // Reset left ear
            setHearingLossTypeLeft('');
            setHearingLossDegreeLeft('');
            setHearingLossConfigLeft('');
            setHearingLossDurationLeft('');
            setJhqSeverity('');
            setJhqValue('');
            setHqStatus('');
            setHqValue('');
            setRecommendations({
                ent: false,
                soundTherapy: false,
                psychology: false,
                neurology: false,
                psychiatric: false,
                yoga: false
            });
        } catch (error) {
            console.error("Error:", error);
            alert(`❌ ${error.message}`);
        }
    };

    // Helper component for hearing loss details for each ear
    const HearingLossEarDetails = ({ 
        ear, 
        type, setType, 
        degree, setDegree, 
        config, setConfig, 
        duration, setDuration 
    }) => {
        return (
            <>
                <Grid item xs={12} sm={3}>
                    <FormControl fullWidth size="small">
                        <InputLabel shrink={true}>Type of HL ({ear})</InputLabel>
                        <Select
                            value={type}
                            onChange={(e) => setType(e.target.value)}
                            label={`Type of HL (${ear})`}
                            displayEmpty
                            renderValue={value => value || `Select Type of HL (${ear})`}
                        >
                            <MenuItem value="">Select</MenuItem>
                            <MenuItem value="Conductive">Conductive</MenuItem>
                            <MenuItem value="Mixed">Mixed</MenuItem>
                            <MenuItem value="Sensorineural">Sensorineural</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item xs={12} sm={3}>
                    <FormControl fullWidth size="small">
                        <InputLabel shrink={true}>Degree of HL ({ear})</InputLabel>
                        <Select
                            value={degree}
                            onChange={(e) => setDegree(e.target.value)}
                            label={`Degree of HL (${ear})`}
                            displayEmpty
                            renderValue={value => value || `Select Degree of HL (${ear})`}
                        >
                            <MenuItem value="">Select</MenuItem>
                            <MenuItem value="Minimal (75 to 90)">Minimal (75 to 90)</MenuItem>
                            <MenuItem value="Mild (50 to 74)">Mild (50 to 74)</MenuItem>
                            <MenuItem value="Moderate (30 to 49)">Moderate (30 to 49)</MenuItem>
                            <MenuItem value="Severe (0 to 29)">Severe (0 to 29)</MenuItem>
                            <MenuItem value="Profound">Profound</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item xs={12} sm={3}>
                    <FormControl fullWidth size="small">
                        <InputLabel shrink={true}>Configuration ({ear})</InputLabel>
                        <Select
                            value={config}
                            onChange={(e) => setConfig(e.target.value)}
                            label={`Configuration (${ear})`}
                            displayEmpty
                            renderValue={value => value || `Select Configuration (${ear})`}
                        >
                            <MenuItem value="">Select</MenuItem>
                            <MenuItem value="Gradually Sloping">Gradually Sloping</MenuItem>
                            <MenuItem value="Steeply Sloping">Steeply Sloping</MenuItem>
                            <MenuItem value="Precipitously Sloping">Precipitously Sloping</MenuItem>
                            <MenuItem value="4kHz Notch">4kHz Notch</MenuItem>
                            <MenuItem value="Cookiebite">Cookiebite</MenuItem>
                            <MenuItem value="Raising">Raising</MenuItem>
                            <MenuItem value="Flat">Flat</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        label={`Duration of Hearing Loss (${ear})`}
                        value={duration}
                        onChange={(e) => setDuration(e.target.value)}
                        fullWidth
                        size="small"
                    />
                </Grid>
            </>
        );
    };

    return (
        <Box sx={{ maxWidth: 1200, margin: 'auto', p: 3 }}>
          
            <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
                <Typography variant="h4" gutterBottom fontWeight="bold" color="secondary" align="center">
                    Hyperacusis Management System
                </Typography>
                  
                <Box mb={4} border={1} borderColor="divider" p={2} borderRadius={2}>
                    <Typography variant="h5" gutterBottom fontWeight="bold" color="secondary">
                        Patient Identification
                    </Typography>
                    {/* Search Section - Always visible */}
                    <Box mb={4} border={1} borderColor="divider" p={2} borderRadius={2}>
                        <Grid container spacing={3} alignItems="center">
                            <Grid item xs={12} md={6}>
                                <TextField
                                    label="IP/OP/Internal Number"
                                    value={opNumber}
                                    onChange={(e) => setOpNumber(e.target.value)}
                                    variant="outlined"
                                    size="small"
                                    sx={{ flexGrow: 1, mr: 2 }}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    startIcon={<SearchIcon />}
                                    onClick={handleSearch}
                                >
                                    Search Patient
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>

                {/* Patient Information - Visible after search */}
                {patientData && (
                    <Paper elevation={2} sx={{ p: 2, mb: 3, backgroundColor: '#e3f2fd' }}>
                            <Box sx={{ position: 'absolute', top: 310, right: 140 }}>
              <Button
                variant="contained"
                color="secondary"
                startIcon={<DownloadIcon />}
                onClick={handleDownloadClick}
                disabled={loading}
                sx={{ 
                  borderRadius: 2,
                  boxShadow: 2,
                  '&:hover': {
                    boxShadow: 4,
                    transform: 'translateY(-2px)',
                    transition: 'all 0.3s ease'
                  }
                }}
              >
                Download 
              </Button>
            </Box>
                        <Typography variant="h5" gutterBottom fontWeight="bold" color="secondary">
                            Patient Information
                        </Typography>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} md={3}>
                                <Typography><strong>Name:</strong> {patientData.name}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <Typography><strong>Age:</strong> {patientData.age}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <Typography><strong>ip_number:</strong> {patientData.ip_number}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <Typography><strong>Phone:</strong> {patientData.phone}</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography><strong>Medical History:</strong> {patientData.history}</Typography>
                            </Grid>
                        </Grid>
                    </Paper>
                )}

                {/* All other sections - Visible only after patient is found */}
                {patientData && (
                    <>
                        {/* Cause of Hyperacusis Section */}
                        <Paper elevation={2} sx={{ p: 2, mb: 3 }}>
                            <Box mb={4} border={1} borderColor="divider" p={2} borderRadius={2}>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        fullWidth
                                        name="dateOfAssessment"
                                        label="Date of Assessment"
                                        type="date"
                                        value={date}
                                        onChange={(e) => setDate(e.target.value)}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                <Typography variant="h5" gutterBottom fontWeight="bold" color="secondary">
                                    Cause of Hyperacusis
                                </Typography>
                                <IconButton onClick={() => toggleSection('cause')}>
                                    {expanded.cause ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                </IconButton>
                            </Box>

                            <Collapse in={expanded.cause}>
                                <Grid container spacing={2}>
                                    {/* Otological Causes */}
                                    <Grid item xs={12} md={4}>
                                        <Typography fontWeight="bold" gutterBottom>Otological Cause:</Typography>
                                        <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                                            <InputLabel shrink={true}>Select Cause</InputLabel>
                                            <Select
                                                value={otologicalCause}
                                                onChange={(e) => setOtologicalCause(e.target.value)}
                                                label="Select Cause"
                                                displayEmpty
                                                renderValue={value => value || "Select Cause"}
                                            >
                                                <MenuItem value="">None</MenuItem>
                                                <MenuItem value="Otitis media with effusion">Otitis media with effusion</MenuItem>
                                                <MenuItem value="Bells Palsy">Bells Palsy</MenuItem>
                                                <MenuItem value="Ramsay Hunt syndrome">Ramsay Hunt syndrome</MenuItem>
                                                <MenuItem value="Stapedectomy">Stapedectomy</MenuItem>
                                                <MenuItem value="Perilymphatic fistula">Perilymphatic fistula</MenuItem>
                                                <MenuItem value="Lyme disease">Lyme disease</MenuItem>
                                                <MenuItem value="Other">Other</MenuItem>
                                            </Select>
                                        </FormControl>
                                        {otologicalCause === 'Other' && (
                                            <TextField
                                                label="Specify Other Cause"
                                                value={otologicalOther}
                                                onChange={(e) => setOtologicalOther(e.target.value)}
                                                fullWidth
                                                size="small"
                                            />
                                        )}
                                    </Grid>

                                    {/* Neurological Causes */}
                                    <Grid item xs={12} md={4}>
                                        <Typography fontWeight="bold" gutterBottom>Neurological Cause:</Typography>
                                        <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                                            <InputLabel shrink={true}>Select Cause</InputLabel>
                                            <Select
                                                value={neurologicalCause}
                                                onChange={(e) => setNeurologicalCause(e.target.value)}
                                                label="Select Cause"
                                                displayEmpty
                                                renderValue={value => value || "Select Cause"}
                                            >
                                                <MenuItem value="">None</MenuItem>
                                                <MenuItem value="Migraine">Migraine</MenuItem>
                                                <MenuItem value="William syndrome">William syndrome</MenuItem>
                                                <MenuItem value="Other">Other</MenuItem>
                                            </Select>
                                        </FormControl>
                                        {neurologicalCause === 'Other' && (
                                            <TextField
                                                label="Specify Other Cause"
                                                value={neurologicalOther}
                                                onChange={(e) => setNeurologicalOther(e.target.value)}
                                                fullWidth
                                                size="small"
                                            />
                                        )}
                                    </Grid>

                                    {/* Psychological Causes */}
                                    <Grid item xs={12} md={4}>
                                        <Typography fontWeight="bold" gutterBottom>Psychological Cause:</Typography>
                                        <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                                            <InputLabel shrink={true}>Select Cause</InputLabel>
                                            <Select
                                                value={psychologicalCause}
                                                onChange={(e) => setPsychologicalCause(e.target.value)}
                                                label="Select Cause"
                                                displayEmpty
                                                renderValue={value => value || "Select Cause"}
                                            >
                                                <MenuItem value="">None</MenuItem>
                                                <MenuItem value="Depression">Depression</MenuItem>
                                                <MenuItem value="Post traumatic stress disorder">Post traumatic stress disorder</MenuItem>
                                                <MenuItem value="Other">Other</MenuItem>
                                            </Select>
                                        </FormControl>
                                        {psychologicalCause === 'Other' && (
                                            <TextField
                                                label="Specify Other Cause"
                                                value={psychologicalOther}
                                                onChange={(e) => setPsychologicalOther(e.target.value)}
                                                fullWidth
                                                size="small"
                                            />
                                        )}
                                    </Grid>
                                </Grid>
                            </Collapse>
                        </Paper>

                        {/* Hearing Loss Section */}
                        <Paper elevation={2} sx={{ p: 2, mb: 3 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                <Typography variant="h5" gutterBottom fontWeight="bold" color="secondary">
                                    Hearing Loss
                                </Typography>
                                <IconButton onClick={() => toggleSection('hearingLoss')}>
                                    {expanded.hearingLoss ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                </IconButton>
                            </Box>

                            <Collapse in={expanded.hearingLoss}>
                                <Grid container spacing={2} alignItems="center">
                                    <Grid item xs={12} sm={3}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={hearingLossPresent}
                                                    onChange={(e) => setHearingLossPresent(e.target.checked)}
                                                    color="primary"
                                                />
                                            }
                                            label="Hearing Loss Present"
                                        />
                                    </Grid>

                                    {hearingLossPresent && (
                                        <>
                                            {/* Ear Dropdown */}
                                            <Grid item xs={12} sm={3}>
                                                <FormControl fullWidth size="small">
                                                    <InputLabel shrink={true}>Ear</InputLabel>
                                                    <Select
                                                        value={hearingLossEar}
                                                        onChange={(e) => setHearingLossEar(e.target.value)}
                                                        label="Ear"
                                                        displayEmpty
                                                        renderValue={value => value || "Select Ear"}
                                                    >
                                                        <MenuItem value="">Select</MenuItem>
                                                        <MenuItem value="Right">Right</MenuItem>
                                                        <MenuItem value="Left">Left</MenuItem>
                                                        <MenuItem value="Both">Both</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </Grid>

                                            {/* Right Ear Details */}
                                            {(hearingLossEar === "Right" || hearingLossEar === "Both") && (
                                                <HearingLossEarDetails 
                                                    ear="Right"
                                                    type={hearingLossTypeRight}
                                                    setType={setHearingLossTypeRight}
                                                    degree={hearingLossDegreeRight}
                                                    setDegree={setHearingLossDegreeRight}
                                                    config={hearingLossConfigRight}
                                                    setConfig={setHearingLossConfigRight}
                                                    duration={hearingLossDurationRight}
                                                    setDuration={setHearingLossDurationRight}
                                                />
                                            )}
                                            
                                            {/* Left Ear Details */}
                                            {(hearingLossEar === "Left" || hearingLossEar === "Both") && (
                                                <HearingLossEarDetails 
                                                    ear="Left"
                                                    type={hearingLossTypeLeft}
                                                    setType={setHearingLossTypeLeft}
                                                    degree={hearingLossDegreeLeft}
                                                    setDegree={setHearingLossDegreeLeft}
                                                    config={hearingLossConfigLeft}
                                                    setConfig={setHearingLossConfigLeft}
                                                    duration={hearingLossDurationLeft}
                                                    setDuration={setHearingLossDurationLeft}
                                                />
                                            )}
                                        </>
                                    )}
                                </Grid>
                            </Collapse>
                        </Paper>

                        {/* JHQ Section */}
                        <Paper elevation={2} sx={{ p: 2, mb: 3 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                <Typography variant="h5" gutterBottom fontWeight="bold" color="secondary">
                                    JHQ (Jastreboff Hyperacusis Questionnaire)
                                </Typography>
                                <IconButton onClick={() => toggleSection('jhq')}>
                                    {expanded.jhq ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                </IconButton>
                            </Box>

                            <Collapse in={expanded.jhq}>
                                <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                                    <InputLabel id="jhq-level-label" shrink={true}>Select Severity</InputLabel>
                                    <Select
                                        labelId="jhq-level-label"
                                        value={jhqSeverity}
                                        onChange={(e) => setJhqSeverity(e.target.value)}
                                        label="Select Severity"
                                        displayEmpty
                                        renderValue={value => value || "Select Severity"}
                                    >
                                        <MenuItem value="Mild">Mild (75 to 90)</MenuItem>
                                        <MenuItem value="Moderate">Moderate (50 to 74)</MenuItem>
                                        <MenuItem value="Severe">Severe (30 to 49)</MenuItem>
                                        <MenuItem value="Profound">Profound (0 to 29)</MenuItem>
                                    </Select>
                                </FormControl>

                                {jhqSeverity && (
                                    <TextField
                                        label="Enter JHQ Score"
                                        value={jhqValue}
                                        onChange={(e) => setJhqValue(e.target.value)}
                                        fullWidth
                                        size="small"
                                        helperText="Hyperacusis present if score > 28"
                                    />
                                )}
                            </Collapse>
                        </Paper>

                        {/* HQ Section */}
                        <Paper elevation={2} sx={{ p: 2, mb: 3 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                <Typography variant="h5" gutterBottom fontWeight="bold" color="secondary">
                                    HQ (Hyperacusis Questionnaire)
                                </Typography>
                                <IconButton onClick={() => toggleSection('hq')}>
                                    {expanded.hq ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                </IconButton>
                            </Box>

                            <Collapse in={expanded.hq}>
                                <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                                    <InputLabel id="hq-status-label" shrink={true}>Select Status</InputLabel>
                                    <Select
                                        labelId="hq-status-label"
                                        value={hqStatus}
                                        onChange={(e) => setHqStatus(e.target.value)}
                                        label="Select Status"
                                        displayEmpty
                                        renderValue={value => value || "Select Status"}
                                    >
                                        <MenuItem value="present">Hyperacusis present</MenuItem>
                                        <MenuItem value="absent">Hyperacusis absent</MenuItem>
                                    </Select>
                                </FormControl>

                                {hqStatus && (
                                    <TextField
                                        label="Enter HQ Score"
                                        value={hqValue}
                                        onChange={(e) => setHqValue(e.target.value)}
                                        fullWidth
                                        size="small"
                                        helperText={
                                            <span>
                                                Reference: Fackrell, K., Fearnley, C., Hoare, D. J., & Sereda, M. (2015).
                                                Hyperacusis questionnaire as a tool for measuring hypersensitivity to sound in a tinnitus research population.
                                                <em>BioMed research international</em>, 2015.
                                                <a
                                                    href="https://www.researchgate.net/file.PostFileLoader.html?id=545bb67cd5a3f21e0d8b4713&assetKey=AS%3A273713788850182%401442269860749"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{ marginLeft: '5px' }}
                                                >
                                                    View Study
                                                </a>
                                            </span>
                                        }
                                    />
                                )}
                            </Collapse>
                        </Paper>

                        {/* Recommendations Section */}
                        <Paper elevation={2} sx={{ p: 2, mb: 3 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                <Typography variant="h5" gutterBottom fontWeight="bold" color="secondary">
                                    Recommendations
                                </Typography>
                                <IconButton onClick={() => toggleSection('recommendations')}>
                                    {expanded.recommendations ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                </IconButton>
                            </Box>

                            <Collapse in={expanded.recommendations}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={recommendations.ent}
                                                    onChange={handleRecommendationChange('ent')}
                                                    color="primary"
                                                />
                                            }
                                            label="ENT"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={recommendations.soundTherapy}
                                                    onChange={handleRecommendationChange('soundTherapy')}
                                                    color="primary"
                                                />
                                            }
                                            label="Sound Therapy"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={recommendations.psychology}
                                                    onChange={handleRecommendationChange('psychology')}
                                                    color="primary"
                                                />
                                            }
                                            label="Psychology"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={recommendations.neurology}
                                                    onChange={handleRecommendationChange('neurology')}
                                                    color="primary"
                                                />
                                            }
                                            label="Neurology"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={recommendations.psychiatric}
                                                    onChange={handleRecommendationChange('psychiatric')}
                                                    color="primary"
                                                />
                                            }
                                            label="Psychiatric"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={recommendations.yoga}
                                                    onChange={handleRecommendationChange('yoga')}
                                                    color="primary"
                                                />
                                            }
                                            label="Yoga and Meditation"
                                        />
                                    </Grid>
                                </Grid>
                            </Collapse>
                        </Paper>
     <Dialog 
        open={openPasswordModal} 
        onClose={handlePasswordModalClose}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          Download Data
          <IconButton
            aria-label="close"
            onClick={handlePasswordModalClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2, mb: 2 }}>
            <TextField
              fullWidth
              label="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              variant="outlined"
              sx={{ mb: 3 }}
            />
            <FormControl fullWidth>
              <InputLabel>Format</InputLabel>
              <Select
                value={downloadFormat}
                onChange={(e) => setDownloadFormat(e.target.value)}
                label="Format"
              >
                <MenuItem value="excel">Excel</MenuItem>
                <MenuItem value="pdf">PDF</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={handlePasswordModalClose} color="inherit">
            Cancel
          </Button>
          <Button 
            onClick={handleDownloadConfirm} 
            variant="contained" 
            color="primary"
            disabled={!password}
          >
            Download
          </Button>
        </DialogActions>
      </Dialog>
                        {/* Submit Button */}
                        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                            <Button
                                variant="contained"
                                color="primary"
                                size="large"
                                onClick={handleSubmit}
                                sx={{ fontSize: '1.1rem', px: 6, py: 1.5 }}
                            >
                                Submit Hyperacusis Data
                            </Button>
                        </Box>
                    </>
                )}
            </Paper>
        </Box>
    );
};

export default Hyperacusis;